/**
 * This is an async wrapper for waiting a promise to be settled without the hussle of handling error.
 * It returns `[error, data]`.
 * @example
 * ```js
 * const [error, data] = await to(myPromise())
 * ```
 * @param promise - promise to be awaited for.
 * @param errorExt - error to be appended, in case the promise is rejected.
 */
async function to(
	promise: Promise<unknown>,
	errorExt?: object,
): Promise<any[] | unknown[]> {
	try {
		const data = await promise;

		return [null, data];
	} catch (err) {
		if (errorExt) {
			Object.assign(err, errorExt);
		}

		return [err, undefined];
	}
}

export default to;
